
    import { Component, Inject, Vue } from "vue-property-decorator"
    import Layout from "@/app/common/components/layout/layout.vue"
    import { mapGetters } from "vuex"
    import { ProductAction } from "@/app/product/entities/product-action.entity"
    import { GetAllActionsCommand } from "@/app/product/commands/get-all-actions.command"

    @Component({
        components: { Layout },
        metaInfo() {
            return {
                title: 'Eidas'
            }
        },
        computed: {
            ...mapGetters('product', ['getByProductActionId'])
        }
    })
    export default class StartEidasJourney extends Vue {
        productAction?: ProductAction | null = null
        getByProductActionId!: (id: string) => ProductAction | undefined

        @Inject() getAllActionsCommand!: GetAllActionsCommand

        async mounted() {
            await this.getAllActionsCommand.run()
            const id = this.$route.params.action
            this.productAction = this.getByProductActionId(id) ?? null
        }

        get url(): string|null {
            return this.productAction?.eidasUrl ?? null
        }

        get title(): string {
            // Titel: "Identificeer {naam} via de Vidua-app. Deze identificatie is beveiligd volgens de eIDAS-norm."
            const prefix = this.$t('productaction.START_EIDAS_JOURNEY.title').toString()
            const suffix = this.$t('productaction.START_EIDAS_JOURNEY.title_suffix').toString()
            const name = this.productAction?.consumerName

            return name ? `${prefix} ${name} ${suffix}` : prefix
        }
    }
